import { useCallback, useEffect, useState } from "react";
import QuestionSelectorItem from "./QuestionSelectorItem";

export default function QuestionSelector({
  questions = [], // Default: empty array
  mode = "single", // Default: "single"
  onSelectionChange, // No explicit default, handled conditionally
  initialSelectedIds = [], // Default: empty array
  imageClass = "", // Default: empty string
  valueKey = "id", // Default: "id"
  imagesCache
}) {
  const [selectedIds, setSelectedIds] = useState(
    () => new Set(initialSelectedIds)
  );

  // Sync with initialSelectedIds changes from parent
  useEffect(() => {
    setSelectedIds(new Set(initialSelectedIds));
  }, [initialSelectedIds]);

  // Memoize handler to prevent unnecessary rerenders
  const handleSelectQuestion = useCallback(
    (question) => {
      const currentSelectedIds = new Set(initialSelectedIds);
      let newSelectedIds;

      if (mode === "single") {
        newSelectedIds = new Set();
        // In single mode, clicking an already selected item will deselect it
        if (!currentSelectedIds.has(question[valueKey])) {
          newSelectedIds.add(question[valueKey]);
        }
      } else {
        newSelectedIds = new Set(currentSelectedIds);
        // Toggle selection in multiple mode
        if (newSelectedIds.has(question[valueKey])) {
          newSelectedIds.delete(question[valueKey]);
        } else {
          newSelectedIds.add(question[valueKey]);
        }
      }

      // Only emit to parent component, don't update internal state
      if (onSelectionChange) {
        onSelectionChange(Array.from(newSelectedIds));
      }
    },
    [mode, onSelectionChange, initialSelectedIds, valueKey]
  );

  if (!questions.length) {
    return (
      <div className="question-selector-empty">No questions available</div>
    );
  }

  return (
    <div className="keduall-question-selector">
      {questions.map((question) => (
        <QuestionSelectorItem
          key={question[valueKey]}
          thumbnail={imagesCache?.[question?.img]?.src || question?.img}
          tag={question.tag}
          imageClass={imageClass}
          selected={selectedIds.has(question[valueKey])}
          onSelected={() => handleSelectQuestion(question)}
          mode={mode}
        />
      ))}
    </div>
  );
}
